module.exports = __webpack_public_path__ + "static/media/addressOn.a66447e5.svg";